export default {
    localStorageNamespace: "WILLOW_ADMIN",
    apiTokenCheckPeriod: 59,//    60 == 1 min
    apiStatusCheckPeriod: 61
};
